import { Button } from "antd"
import React from "react"

import { cn } from "../../../utils/cn.ts"

const TONE_CLASSES = {
  amber: "bg-amber-50 text-amber-600",
  blue: "bg-blue-50 text-blue-600"
} as const

interface CustomerActionRowProps {
  icon: React.ReactNode
  tone?: keyof typeof TONE_CLASSES
  title: React.ReactNode
  subtitle: React.ReactNode
  actionLabel: React.ReactNode
  onAction: () => void
}

/** One row in "Needs your attention" — a real outstanding item, never a
 * placeholder. Icon tile, title + metadata line, and a same-row action that
 * opens the exact item (never a generic "view" that lands somewhere else). */
export function CustomerActionRow({
  icon,
  tone = "amber",
  title,
  subtitle,
  actionLabel,
  onAction
}: CustomerActionRowProps) {
  return (
    <div className="flex min-h-[76px] flex-col gap-3 py-3 first:pt-0 last:pb-0 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <div className="flex min-w-0 items-center gap-4">
        <div
          className={cn(
            "flex size-11 shrink-0 items-center justify-center rounded-lg text-lg",
            TONE_CLASSES[tone]
          )}
        >
          {icon}
        </div>
        <div className="min-w-0">
          <p className="text-[15px] font-medium text-gray-900">{title}</p>
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>
      </div>
      <Button className="shrink-0 sm:min-w-[140px]" onClick={onAction}>
        {actionLabel}
      </Button>
    </div>
  )
}
